import { GridLayout } from "../../../Models/GridLayout";

export const createcustomDataHeaderGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--custom-data-header-columns": layout.columns,
    "--custom-data-header-areas": layout.areas,
  }) as React.CSSProperties;

export const createcustomDatasListItemrGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--custom-data-list-columns": layout.columns,
    "--custom-data-list-areas": layout.areas,
  }) as React.CSSProperties;

export const createcustomDataFooterGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--custom-data-footer-columns": layout.columns,
    "--custom-data-footer-areas": layout.areas,
  }) as React.CSSProperties;
